/* eslint-disable */
import React from 'react'
import { View, Text, StyleSheet, Image, TouchableWithoutFeedback } from 'react-native'
import imageLabel from '../assets/images/label.png'
import imageIconDictionary from '../assets/images/icon-dictionary.png'
import imageIconSettings from '../assets/images/icon-settings.png'

const styles = StyleSheet.create({
  container: {
    paddingTop: 15,
    paddingBottom: 7,
    alignItems: 'center',
  },
  
  link: {
    position: 'absolute',
    right: 5,
    top: 6,
    paddingTop: 10,
    paddingRight: 10,
    paddingLeft: 10,
    paddingBottom: 10,
  },
  
  linkDictionary: {
    position: 'absolute',
    left: 5,
    top: 6,
    paddingTop: 10,
    paddingRight: 10,
    paddingLeft: 10,
    paddingBottom: 10,
  },
})

export default class TopBar extends React.Component {
  constructor(props) {
    super(props)
    
    this.state = {
    }
  }
  
  onPress(item) {
    this.props.onPressLink(item)
  }
  
  render() {
    return (
      <View style={styles.container}>
        <TouchableWithoutFeedback onPress={() => this.props.emit('showDictionaryOverlay')}>
          <View style={styles.linkDictionary}>
            <Image source={imageIconDictionary} style={{width: 29, height: 29}} />
          </View>
        </TouchableWithoutFeedback>
        <Image source={imageLabel} style={{width: 131, height: 39}} />
        <TouchableWithoutFeedback onPress={() => this.props.emit('showSettingsOverlay')}>
          <View style={styles.link}>
            <Image source={imageIconSettings} style={{width: 25, height: 29}} />
          </View>
        </TouchableWithoutFeedback>
      </View>
    )
  }
}
